export const SEARCH_CHECK = 'SEARCH_CHECK';
export const SEARCH_CHECK_VALUES = 'SEARCH_CHECK_VALUES';
export const SAVE_CHECK_VALUES = 'SAVE_CHECK_VALUES';
export const DELETE_CHECK_VALUES = 'DELETE_CHECK_VALUES';
export const VIEW_HISTORY = 'VIEW_HISTORY';
export const ALL_LAST_UPDATED_USER_ID = 'ALL_LAST_UPDATED_USER_ID';
export const GET_GENERAL_SYSTEM_PARAMETER_CHECK =
  'GET_GENERAL_SYSTEM_PARAMETER_CHECK';
export const COMMON_COMMENTS_DROPDOWN = 'COMMON_COMMENTS_DROPDOWN';
export const COMMON_COMMENTS_DATA = 'COMMON_COMMENTS_DATA';
export const GET_LINK_TABLE_DATA = 'GET_LINK_TABLE_DATA';
export const GET_USER_ROLE = 'GET_USER_ROLE';
